import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import Process from "@/components/Process";
import Stats from "@/components/Stats";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Landing = () => {
  return (
    <main data-testid="landing-page" className="relative bg-[#060B14] text-[#F0F4F8]">
      <Navbar />
      <Hero />
      <Marquee />
      <About />
      <Services />
      <WhyUs />
      <Process />
      <Stats />
      <Contact />
      <Footer />
    </main>
  );
};

export default Landing;
